/**
 * Platform detection. Used to apply mobile-only behaviour tweaks
 * (e.g. dice energy-gain boost) without affecting touch laptops.
 *
 * Returns true ONLY for actual Android / iOS devices (native Capacitor
 * shell OR a mobile browser running our PWA over LAN). Touch-capable
 * Windows laptops, Surfaces, Chromebooks etc. return false.
 */

import { Capacitor } from '@capacitor/core';

let cachedIsMobile: boolean | null = null;

export function isMobilePlatform(): boolean {
  if (cachedIsMobile !== null) return cachedIsMobile;
  // Capacitor native build is the definitive case.
  if (Capacitor.isNativePlatform()) {
    const p = Capacitor.getPlatform();
    cachedIsMobile = p === 'ios' || p === 'android';
    return cachedIsMobile;
  }
  // Browser case — match the UA. Covers testing the dev build on the
  // phone over LAN (the use case that exposed the dice-energy gap).
  // iPadOS 13+ reports as Mac in UA; include the maxTouchPoints check
  // to catch it. Touch-laptops report platform='Win32' and pass this.
  const ua = navigator.userAgent;
  const isAndroidOrIOS = /Android|iPhone|iPod/i.test(ua);
  const isIpadOS =
    /Macintosh/.test(ua) && typeof navigator.maxTouchPoints === 'number' && navigator.maxTouchPoints > 1;
  cachedIsMobile = isAndroidOrIOS || isIpadOS;
  return cachedIsMobile;
}
